// 增加网络状态监听
import { message } from 'antd';
import EventBus from '@/utils/eventBus.ts';
const handleNetworkChange = () => {
  window.online = navigator.onLine;
  // 通知其他程序恢复了网络
  window.online && EventBus.emit('networkChangeOnline');
  if (!window.online) {
    EventBus.emit('networkQualityShow');
    message.error('网络离线, 请检查网络连接');
    EventBus.emit('networkQualityChange', {
      type: null,
      downlink: 0, // 预估下行速度(Mbps)
      effectiveType: 'offline', // 网络类型
      rtt: -1, // 往返时间
      saveData: null, // 是否开启省流模式
      lastUpdate: new Date(),
    });
  }
  console.log(`网络状态: ${window.online ? '在线' : '离线'}`);
};

window.addEventListener('online', handleNetworkChange);
window.addEventListener('offline', handleNetworkChange);

// 网络状态监听器
const initNetworkMonitoring = () => {
  const connection =
    navigator.connection ||
    (navigator as any).mozConnection ||
    (navigator as any).webkitConnection;

  if (!connection) {
    console.warn('Network Information API not supported');
    return;
  }

  const handleConnectionChange = () => {
    const networkState = {
      // type: connection.type,
      downlink: connection.downlink, // 预估下行速度(Mbps)
      effectiveType: connection.effectiveType, // 网络类型
      rtt: connection.rtt, // 往返时间
      saveData: connection.saveData, // 是否开启省流模式
      lastUpdate: new Date(),
    };
    // 触发全局事件
    EventBus.emit('networkQualityChange', networkState);

    // 根据网络类型显示提示
    if (networkState.effectiveType === 'slow-2g') {
      message.warning('网络质量较差，部分功能可能受限');
      EventBus.emit('networkQualityShow');
    }

    // 公司代理检测逻辑
    if (connection.rtt > 1000 && connection.downlink < 1) {
      message.warning('网络延迟大, 连接异常, 请检查网络环境 / VPN设置');
      EventBus.emit('networkQualityShow');
    }
  };

  // 添加监听
  connection.addEventListener('change', handleConnectionChange);

  // 立即执行一次获取初始状态
  handleConnectionChange();
};

// 在应用初始化时调用
initNetworkMonitoring();
// 浏览器端检测
// function detectProxy() {
//   const rtc = new RTCPeerConnection({
//     iceServers: [{ urls: 'stun:stun.l.google.com:19302' }],
//   });
//
//   rtc.createDataChannel('');
//   rtc.createOffer().then((offer) => rtc.setLocalDescription(offer));
//
//   rtc.onicecandidate = async (e) => {
//     if (e.candidate) {
//       const ip = e.candidate.address;
//       if (ip) {
//         const result = await isItDomestic(ip);
//         debugger
//         if (result) {
//           console.warn('检测到国外IP，可能使用代理');
//         }
//       }
//     }
//   };
// }
//
// async function isItDomestic(ip: string): Promise<boolean> {
// }
// detectProxy();
